export const tabs = {
  tab: {
    padding: '0.7rem 0.712rem',
  },
};
